if (!customElements.get('nosto-collection-item')) {

let bisFormTimeout;
  class nostoCollectionItem extends HTMLElement {
    constructor() {
      super();
      this.observedAttributes = ["data-collection"];
      this.international = this.getAttribute("data-international");
      this.singleProduct = this.getAttribute("data-single-product");
      this.trackType = this.getAttribute("data-type");
      this.gendered = this.getAttribute("data-gendered");
      this.data = JSON.parse(this.querySelector("data.nosto-data").innerHTML);
      if (this.data.alternateImageUrls) {
        this.data.alternateImageUrls.unshift(this.data.imageUrl);
      } else {
        this.data.alternateImageUrls = [this.data.imageUrl, this.data.imageUrl];
      }
      this.discountPercentage = Math.round(
        100 - (parseInt(this.data.price) / parseInt(this.data.listPrice)) * 100
      );
      this.isDiscount = false;
      if (parseInt(this.data.price) < parseInt(this.data.listPrice)) {
        this.isDiscount = true;
      }
      this.createItem();
      this.savedSwatched = null;
      this.categories = this.data.categories?.map((category) =>
        category.toLowerCase()
      );
      this.collectionHandle = this.getAttribute("data-collection-handle");
      this.collectionData = null;
      this.extraProductData = null;
    }
    static get observedAttributes() {
      return ["data-collection", "data-single-product"];
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (
        name == "data-collection" &&
        newValue == "true" &&
        oldValue == "false"
      ) {
        this.collectionData = collectionData[this.collectionHandle];
        this.collectionData.products.forEach((prod) => {
          if (prod.productId == this.data.productId) {
            this.extraProductData = prod;
            this.querySelectorAll("[intl-price]").forEach((intl) => {
              intl.innerHTML = prod.price;
            });
            this.querySelectorAll("[intl-listPrice]").forEach((intl) => {
              intl.innerHTML = prod.listPrice;
            });
          }
        });
        this.createSwatches();
        this.createProductSelector();
      }
      if (
        name == "data-single-product" &&
        newValue == "true" &&
        oldValue == "false"
      ) {
        this.singleProduct = "true";
        this.getSingleProductData();
      }
    }
    createItem() {
      var collection_badge = null;
      var product_icon = "";
        if(this.data.url.indexOf(document.location.host) > -1){
          var itemUrl = this.data.url;
        } else {
          var itemUrl = (Shopify.routes.root + this.data.url).replaceAll('//', '/');
        }
      this.data?.tags1?.forEach((tag) => {
        if (tag.includes("collection_bd:")) {
          collection_badge = tag.replace("collection_bd:", "");
        }
      });
      this.data.metafields.forEach((meta) => {
        if (meta.key == "images-image_icon") {
          product_icon =
            "icon--" + meta.value.toLowerCase().replaceAll(" ", "-");
        }
      });
      var sizeImages = this.data.alternateImageUrls;
      sizeImages.forEach((image, i) => {
        sizeImages[i] = image
          .replace("_450x", "")
          .replace(".jpg", "_450x.jpg")
          .replace(".png", "_450x.png")
          .replace(".jpeg", "_450x.jpeg")
          .replace(".webp", "_450x.webp");
      });
      var itemHtml = `<div class="card-wrapper" id="${this.data.cardPosition}" data-card-page="${this.data.page}" data-card-ref>`;
      itemHtml += "<div>";
      itemHtml += '<span class="visually-hidden">' + this.data.name + "</span>";
      itemHtml += '<div class="card card--product" tabindex="-1">';
      itemHtml +=
      `<a href="${itemUrl.toString()}" class="card__inner full-unstyled-link" track>`;
      itemHtml += "<div>";
      itemHtml += '<div class="media media--portrait cc--hover-effect">';
      if (this.gendered != "" && this.data.videoUnisex == "true") {
        if (this.gendered == "womens") {
          var imageIndex = this.data.videoUnisex_womens_image_position - 1;
          itemHtml +=
            '<div class="first-media"><picture class="' +
            product_icon +
            '"><img src="' +
            sizeImages[imageIndex] +
            '" alt="' +
            this.data.name +
            '" loading="lazy" class="motion-reduce" width="800" height="967"></picture></div>';
          if (this.data.videoDesktop != null) {
            itemHtml +=
              '<div class="second-media video"><video class="videoplayer" autoplay="" muted="" loop="" playsinline="" data-src="' +
              this.data.videoDesktop +
              '"></video></div>';
          } else {
            var hoverImage =
              this.data.videoUnisex_womens_hover_image_position - 1;
            itemHtml +=
              '<div class="second-media"><picture><img src="' +
              sizeImages[hoverImage] +
              '"alt="' +
              this.data.name +
              '"loading="lazy"class="motion-reduce"width="800"height="967"></picture></div>';
          }
        } else if (this.gendered == "mens") {
          var imageIndex = this.data.videoUnisex_mens_image_position - 1;
          itemHtml +=
            '<div class="first-media"><picture class="' +
            product_icon +
            '"><img src="' +
            sizeImages[imageIndex] +
            '" alt="' +
            this.data.name +
            '" loading="lazy" class="motion-reduce" width="800" height="967"></picture></div>';
          if (this.data.videoUnisex_mens_plp_desktop_video != null) {
            itemHtml +=
              '<div class="second-media video"><video class="videoplayer" autoplay="" muted="" loop="" playsinline="" data-src="' +
              this.data.videoUnisex_mens_plp_desktop_video +
              '"></video></div>';
          } else {
            var hoverImage =
              this.data.videoUnisex_mens_hover_image_position - 1;
            itemHtml +=
              '<div class="second-media"><picture><img src="' +
              sizeImages[hoverImage] +
              '"alt="' +
              this.data.name +
              '"loading="lazy"class="motion-reduce"width="800"height="967"></picture></div>';
          }
        }
      } else {
        itemHtml +=
          '<div class="first-media"><picture class="' +
          product_icon +
          '"><img src="' +
          sizeImages[0] +
          '" alt="' +
          this.data.name +
          '" loading="lazy" class="motion-reduce" width="800" height="967"></picture></div>';
        if (this.data.videoDesktop != null && this.data.videoMobile != null) {
          itemHtml +=
            '<div class="second-media video"><video class="videoplayer" autoplay="" muted="" loop="" playsinline="" data-src="' +
            this.data.videoDesktop +
            '"></video></div>';
        } else {
          itemHtml +=
            '<div class="second-media"><picture><img src="' +
            sizeImages[1] +
            '" alt="' +
            this.data.name +
            '" loading="lazy" class="motion-reduce" width="800" height="967"></picture></div>';
        }
      }
      itemHtml += "</div></div></a>";
      if (collection_badge != null) {
        itemHtml +=
          '<div class="card__badge"><span class="badge caption color-subdued" aria-hidden="true">' +
          collection_badge +
          "</span></div>";
      }
      itemHtml += "</div>";
      itemHtml += '<div class="card-information">';
      itemHtml += '<div class="card-information__wrapper">';
      itemHtml += '<div class="card-information__wrapper__main">';
      itemHtml +=
        '<a href="' +
        itemUrl.toString() +
        '" class="card-information__text h6 full-unstyled-link" track>' +
        this.data.name.replace(" - FINAL SALE", "").replace(" - SALE", "");
      itemHtml += "</a>";
      itemHtml += '<div class="p2 card-information__price h4"><dl>';
      if (this.isDiscount == false) {
        itemHtml += '<div class="price__regular">';
        itemHtml +=
          '<dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt>';
      } else {
        itemHtml += '<div class="price__sale">';
      }
      if (this.international == "true" && this.collectionData == null) {
        if (this.isDiscount == false) {
          itemHtml +=
            '<dd class="price"><span class="price-item price-item--regular" intl-price></span></dd>';
        } else {
          var percentDiscount = this.discountPercentage;
          itemHtml +=
            '<dd class="price price__compare"><s class="price-item price-item--regular" intl-listPrice></s></dd>';
          itemHtml +=
            '<dd class="price"><span class="price-item price-item--sale" intl-price></span></dd><span class="ss__pct--off"><i> ' +
            percentDiscount +
            "% Off</i></span>";
        }
      } else if (this.international == "true") {
        if (this.isDiscount == false) {
          itemHtml +=
            '<dd class="price"><span class="price-item price-item--regular">' +
            this.data.price +
            "</span></dd>";
        } else {
          var percentDiscount = this.discountPercentage;
          itemHtml +=
            '<dd class="price price__compare"><s class="price-item price-item--regular">' +
            this.data.listPrice +
            "</s></dd>";
          itemHtml +=
            '<dd class="price"><span class="price-item price-item--sale">' +
            this.data.price +'</span></dd>';
          itemHtml += '<span class="ss__pct--off"><i> ' +
            percentDiscount +
            "% Off</i></span>"
        }
      } else {
        if (this.isDiscount == false) {
          itemHtml +=
            '<dd class="price"><span class="price-item price-item--regular">$' +
            this.data.price +
            "</span></dd>";
        } else {
          var percentDiscount = this.discountPercentage;
          itemHtml +=
            '<dd class="price price__compare"><s class="price-item price-item--regular">$' +
            this.data.listPrice +
            "</s></dd>";
          itemHtml +=
            '<dd class="price"><span class="price-item price-item--sale">$' +
            this.data.price +
            '</span></dd><span class="ss__pct--off"><i> ' +
            percentDiscount +
            "% Off</i></span>";
        }
      }
      if (
        sessionStorage.getItem("discountMessage") != null &&
        this.data.categories?.includes(
          sessionStorage.getItem("applicableCollection")
        )
      ) {
        itemHtml +=
          '<span class="ss__pct--off"><i>&#32;' +
          sessionStorage.getItem("discountMessage") +
          "</i></span>";
      }
      itemHtml += "</div></dl></div>";
      if (this.savedSwatches != null) {
        itemHtml += this.savedSwatches;
      }
      itemHtml += "</div></div></div>";
      itemHtml += "</div></div>";
      if (this.savedSwatches != null) {
        this.querySelector(".card-wrapper").innerHTML = itemHtml;
      } else {
        this.insertAdjacentHTML("beforeend", itemHtml);
      }
      this.querySelectorAll("[track]").forEach((item) => {
        item.addEventListener("click", (e) => {
          e.preventDefault();
          var val = this.data.productId;
          var link = item.getAttribute("href");

          var cardRef = this.querySelector('[data-card-ref]');
          var cardId = cardRef.id;
          var cardPage = cardRef.dataset.cardPage;
          var locationObject = new URL(document.location.href);
          locationObject.searchParams.set('page', cardPage);
          locationObject.hash = cardId;

          history.replaceState(null, null, locationObject.toString());

          nostojs((api) => {
            api.recordSearchClick(this.trackType, {
              productId: val,
              url: link,
            });
          });
          window.location.href = link;
        });
      });
      if (this.singleProduct == "true") {
        this.getSingleProductData();
      }
      if (this.data.videoDesktop != null && this.data.videoMobile != null) {
        var prodVideo = this.querySelector(".cc--hover-effect video");
        prodVideo.addEventListener("mouseover", function () {
          if (prodVideo.getAttribute("data-src") != "") {
            prodVideo.innerHTML =
              '<source src="' +
              prodVideo.getAttribute("data-src") +
              '" type="video/mp4">';
            prodVideo.setAttribute("data-src", "");
          } else {
            prodVideo.play();
          }
        });
        prodVideo.addEventListener("mouseleave", function () {
          prodVideo.load();
          prodVideo.pause();
        });
        if (window.matchMedia("screen and (max-width: 768px)").matches) {
          var vidSlider = this.querySelector(".cc--hover-effect");
          var slider = tns({
            autoWidth: false,
            items: 1,
            gutter: 0,
            slideBy: 1,
            mouseDrag: true,
            swipeAngle: false,
            container: vidSlider,
            speed: 800,
            edgePadding: 0,
            loop: false,
            autoplay: false,
            autoplayTimeout: 7000,
            mode: "gallery",
          });
          slider.events.on("indexChanged", function () {
            if (prodVideo.getAttribute("data-src") != "") {
              prodVideo.innerHTML =
                '<source src="' +
                prodVideo.getAttribute("data-src") +
                '" type="video/mp4">';
              prodVideo.setAttribute("data-src", "");
            } else {
              prodVideo.play();
            }
          });
        }
      }
    }
    getSingleProductData() {
      var mainEl = this;
      fetch(this.data.url + "?view=nosto-api")
        .then((response) => response.text())
        .then(function (data) {
          var toSave = JSON.parse(data);
          mainEl.extraProductData = toSave;
          mainEl.querySelectorAll("[intl-price]").forEach((intl) => {
            intl.innerHTML = toSave.price;
          });
          mainEl.querySelectorAll("[intl-listPrice]").forEach((intl) => {
            intl.innerHTML = toSave.listPrice;
          });
          if (mainEl.extraProductData.swatch != "") {
            var swatchInsert =
              '<ul class="ss__card__swatches"><li class="active" data-id="' +
              mainEl.data.productId +
              '"><a style="background-image: url(' +
              mainEl.extraProductData.swatch +
              ');"></a></li></ul>';
            mainEl
              .querySelector(".card-information__wrapper__main")
              .insertAdjacentHTML("beforeend", swatchInsert);
          }
          mainEl.createProductSelector();
        });
    }
    createSwatches() {
      var all_swatches = this.collectionData.all_swatches;
      var swatchHTML = "";
        var itemUrl = new URL(this.data.url);
        itemUrl.pathname = Shopify.routes.root + itemUrl.pathname;
        itemUrl.pathname = itemUrl.pathname.replace('//', '/')

      if (all_swatches.length > 0) {
        swatchHTML += '<ul class="ss__card__swatches">';
        var availableClass = "";
        if (this.extraProductData.available == false) {
          var availableClass = "not-available";
        }
        swatchHTML +=
          '<li class=" ' +
          availableClass +
          '" data-id="' +
          this.data.productId +
          '"><a style="background-image: url(' +
          this.extraProductData.swatch +
          ');"></a></li>';
        var swatchCount = 1;
        all_swatches.forEach((swatchItem) => {
          if (swatchItem.productId != this.data.productId && swatchCount < 7) {
            swatchHTML +=
              '<li data-id="' +
              swatchItem.productId +
              '"><a style="background-image: url(' +
              swatchItem.swatch_image +
              ');"></a></li>';
            swatchCount = swatchCount + 1;
          }
        });
        if (
          swatchCount == 7 &&
          this.collectionData.products.length > swatchCount
        ) {
          var more = this.collectionData.products.length - 7;
          swatchHTML +=
            '<li class="more desktop"><a href="' +
            itemUrl.toString() +
            '" class="p2">+' +
            more +
            "</a></li>";
        }
        if (swatchCount > 3 && this.collectionData.products.length > 3) {
          var more = this.collectionData.products.length - 3;
          swatchHTML +=
            '<li class="more mobile"><a href="' +
            itemUrl.toString() +
            '" class="p2">+' +
            more +
            "</a></li>";
        }
        swatchHTML += "</ul>";
        this.querySelector(
          ".card-information__wrapper__main"
        ).insertAdjacentHTML("beforeend", swatchHTML);
        this.savedSwatches = swatchHTML;
        this.addSwatchEvents();
      }
    }
    addSwatchEvents() {
      var swatchNodes = this.querySelectorAll(".ss__card__swatches li");
      swatchNodes.forEach((swatch) => {
        swatch.classList.remove("active");
        if (swatch.getAttribute("data-id") == this.data.productId) {
          swatch.classList.add("active");
        }
        swatch.addEventListener(
          "click",
          function () {
            var newId = swatch.getAttribute("data-id");
            if (newId != this.data.productId) {
              this.changeMainProduct(newId);
            }
          }.bind(this)
        );
      });
    }
    createProductSelector() {
        var selectorHtml = '<product-card-selector class="card__quickbuy">';
        var liContainer = '';
        selectorHtml += '<form method="post" action="/cart/add" id="product-card-quickbuy-' + this.extraProductData.productId + '" accept-charset="UTF-8" class="card__quickbuy__form" enctype="multipart/form-data" novalidate="novalidate" data-options-form="">';
        selectorHtml += '<input type="hidden" name="form_type" value="product">';
        selectorHtml += '<input type="hidden" name="utf8" value="✓">';
        selectorHtml += '<select name="id" id="Variants-' + this.extraProductData.productId + '" class="hidden" data-options="true" aria-label="Select Variant">';
        selectorHtml += '<option disabled="" value=""></option>';
        this.extraProductData.variants.forEach((variant, i) => {
            var liClasses = 'card__option__value ';
            var liDisable = '';
            if (variant.available == false) {
                liClasses += 'ss__oos';
                liDisable = 'disabled';
            }
            selectorHtml += '<option data-options-option="true" data-option1="' + variant.option1 + '" data-option2="' + variant.option2 + '" data-option3="' + variant.option3 + '" value="' + variant.id + '">' + variant.title + '</option>';
            liContainer += `<li class="${liClasses}" data-product-name="${this.extraProductData.name}" data-variant-title="${variant.title}" data-variant-id="${variant.id}" data-product-id="${this.extraProductData.productId}">`;
            liContainer += '<input ' + liDisable + ' data-value="true" data-option-index="2" type="checkbox" id="product-collection-grid-quickbuy-' + variant.id + '-' + this.extraProductData.options[1].toLowerCase() + '-' + variant.option2.toLowerCase() + '" class="card__option__value__input" value="' + variant.option2 + '">';
            liContainer += '<label for="product-collection-grid-quickbuy-' + variant.id + '-' + this.extraProductData?.options?.[1]?.toLowerCase() + '-' + variant.option2?.toLowerCase() + '" class="card__option__value__label caption">' + variant.option2 + '</label>';
            liContainer += '</li>';
        });
        selectorHtml += '</select>';
        selectorHtml += '<div class="card__options">';
        selectorHtml += '<div class="card__option" data-option="true" data-option-index="1">';
        selectorHtml +=  `
          <button type="button" class="card__bis-form-trigger" hidden>
          <svg width="14" height="16" viewBox="0 0 14 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden>
            <path d="M13.4737 12.9524V13.7143H0V12.9524L1.49708 11.4286V6.85714C1.49708 4.49524 3.01661 2.41524 5.23977 1.74476V1.52381C5.23977 1.11967 5.39749 0.732083 5.67825 0.446313C5.95901 0.160544 6.33979 0 6.73684 0C7.13389 0 7.51468 0.160544 7.79543 0.446313C8.07619 0.732083 8.23392 1.11967 8.23392 1.52381V1.74476C10.4571 2.41524 11.9766 4.49524 11.9766 6.85714V11.4286L13.4737 12.9524ZM8.23392 14.4762C8.23392 14.8803 8.07619 15.2679 7.79543 15.5537C7.51468 15.8395 7.13389 16 6.73684 16C6.33979 16 5.95901 15.8395 5.67825 15.5537C5.39749 15.2679 5.23977 14.8803 5.23977 14.4762"/>
          </svg>
          Notify Me When Restocked
          </button>
        `
        selectorHtml += '<ul class="card__option__values">';
        selectorHtml += liContainer;
        selectorHtml += '</ul>';
        selectorHtml += '</div>';
        selectorHtml += '</div>';
        selectorHtml += '</form>';
        selectorHtml += '</product-card-selector>';
        if (this.querySelector('product-card-selector') != null) {
            this.querySelector('product-card-selector').remove();
        }
        if (this.extraProductData.options[2] == null) {
            this.querySelector('a.card__inner').insertAdjacentHTML('afterend', selectorHtml);
        }

        this.addOptionsEvents();
    }
    addOptionsEvents() {
      const productOptions = this.querySelectorAll('.card__option__value');
      const bisFormTrigger = this.querySelector('.card__bis-form-trigger');

      productOptions.forEach((option) => {
        option.addEventListener('mouseenter', () => {
          if(option.classList.contains('ss__oos')) {
            clearTimeout(bisFormTimeout);
            bisFormTrigger.removeAttribute('hidden');
            bisFormTrigger.setAttribute('data-product-title',option.dataset.productName);
            bisFormTrigger.setAttribute('data-variant-title', option.dataset.variantTitle);
            bisFormTrigger.setAttribute('data-variant-id', option.dataset.variantId);
            bisFormTrigger.setAttribute('data-product-id', option.dataset.productId);
          }
        })

        option.addEventListener('mouseleave', () => {
          if(option.classList.contains('ss__oos')) {
            bisFormTimeout = setTimeout(() => {
              bisFormTrigger.setAttribute('hidden', true);
            }, 500);
          }
        })
      })

      if(!bisFormTrigger) {
        return;
      }

      bisFormTrigger.addEventListener('mouseenter', () => {
        clearTimeout(bisFormTimeout);
      })

      bisFormTrigger.addEventListener("mouseleave", () => {
        setTimeout(() => {
          bisFormTrigger.setAttribute("hidden", true);
        }, 500);
      });

      bisFormTrigger.addEventListener('click', () => {
        // Gather modal data and submit event
        document.dispatchEvent(new CustomEvent('bisForm:open', {detail: {
          productTitle: bisFormTrigger.dataset.productTitle,
          variantTitle: bisFormTrigger.dataset.variantTitle,
          productId: bisFormTrigger.dataset.productId,
          variantId: bisFormTrigger.dataset.variantId,
        }}))
      })
    }
    changeMainProduct(newProduct) {
        this.collectionData.products.forEach((prod) => {
            if (prod.productId == newProduct) {
                this.extraProductData = prod;
                this.data = prod;
                this.discountPercentage = Math.round((100 - (parseInt(prod.price) / parseInt(prod.listPrice)) * 100));
            }
        });
        this.createItem();
        this.addSwatchEvents();
        this.createProductSelector();
    }
  }
  customElements.define("nosto-collection-item", nostoCollectionItem);
}
if (!customElements.get("nosto-collection")) {
  class nostoCollection extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.collectionArray = [];
      this.collectionData = {};
      this.collectionFilter = [];
      this.collectionFilterOptions = [];
      this.hasUrlFilters = false;
      this.urlObject = new URL(document.location.href);
      this.urlFilters = this.urlObject.searchParams.get("f");
      if (this.urlFilters != null) {
        this.hasUrlFilters = true;
      }
      this.urlPage = this.urlObject.searchParams.get('page');
      this.collectionId = this.getAttribute("data-collection-id");
      this.international = this.getAttribute("data-international");
      this.slotPositions = JSON.parse(this.getAttribute("data-slot-positions"));
      this.slotIds = JSON.parse(this.getAttribute("data-slot-ids"));
      this.slotWidths = JSON.parse(this.getAttribute("data-slot-widths"));
      this.collectionSize = parseInt(this.getAttribute("data-collection-size"));
      this.searchTerm = this.getAttribute("data-search");
      this.visualFilters = this.getAttribute("data-visual-filters");
      this.gendered = this.getAttribute("data-gendered");
      this.gridSize = cc_getCookie("ok_collection_grid");
      let pagination_from = 0;

      /* Add URL pagination logic */
      if(this.urlPage && this.urlPage > 1) {
        pagination_from = (this.urlPage - 1) * this.collectionSize;
      }

      if (this.gridSize == "3") {
        this.querySelector("#main-collection-product-grid").classList.add(
          "collection-grid__list--3"
        );
        this.querySelector("#main-collection-product-grid").classList.remove(
          "collection-grid__list--4"
        );
        this.querySelector("#ss-skeleton-grid").classList.add("placeholder--3");
        this.querySelector("#ss-skeleton-grid").classList.remove(
          "placeholder--4"
        );
      } else {
        this.gridSize = "4";
      }
      this.querySelector("#ss-skeleton-grid").style.visibility = "visible";
      this.getNostoCollection(pagination_from);
      this.querySelector("[data-collection-next] a").addEventListener(
        "click",
        function () {
          var newFrom = parseInt(
            this.querySelector("[data-collection-next] a").getAttribute(
              "data-from"
            )
          );
          this.getNostoCollection(newFrom, undefined, undefined, 'after');
        }.bind(this)
      );
      this.querySelector("[data-load-previous]").addEventListener('click', (e) => {
        var newFrom = parseInt(e.target.dataset.from)
        this.getNostoCollection(newFrom, undefined,undefined, 'before');
      })

      if(this.urlPage > 1) {
        this.intersectionObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) =>{
            if(entry.isIntersecting) {
              this.getNostoCollection(Number.parseInt(entry.target.dataset.from), false, this.collectionSize, 'before');
            }
          })
        }, {
          rootMargin: "300px 0px 0px 0px",
        })
      }

      history.scrollRestoration = "manual";
    }
    getUrlFilters() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var filters = urlParams.get("f");
      var mainEl = this;
      if (filters != null) {
        var parent = filters.split("::");
        parent.forEach((str) => {
          var breakdown = str.split(":");
          var parentName = breakdown[0];
          mainEl.collectionFilterOptions.forEach((main) => {
            if (main.field == parentName) {
              breakdown[1].split(",").forEach((val) => {
                main.data.forEach((dataE) => {
                  if (dataE.value == val) {
                    dataE.selected = true;
                  }
                });
              });
            }
          });
        });
        this.hasUrlFilters = false;
        this.filterCollection();
      }
    }
    getNostoCollection(
      collection_from = 0,
      collection_reset = false,
      collection_size = this.collectionSize,
      collection_direction = null,
    ) {
      var sortArray = [];
      if (this.querySelector("#CollectionSortBy") != null) {
        var sortOption = this.querySelector("#CollectionSortBy option:checked");
        if (sortOption.value != "") {
          sortArray.push({
            field: sortOption.value,
            order: sortOption.getAttribute("data-sort"),
          });
        }
      }
      if (this.hasUrlFilters == false) {
        var newParams = "";
        this.collectionFilter.forEach((para) => {
          if (para.value.length > 0) {
            newParams = newParams + para.field + ":";
            para.value.forEach((val) => {
              newParams = newParams + val + ",";
            });
            newParams = newParams.substring(0, newParams.length - 1) + "::";
          }
        });
        newParams = newParams.substring(0, newParams.length - 2);
        var urlObject = new URL(window.location.href);
        if(collection_reset) {
          urlObject.searchParams.delete('page');
        }
        if (newParams != "") {
          urlObject.searchParams.set("f", newParams);
          history.replaceState(null, null, urlObject.toString());
        } else {
          urlObject.searchParams.delete("f");
          history.replaceState(
            null,
            null,
            urlObject.toString()
          );
        }
      }
      var hasSlots = false;
      if (this.slotIds) {
        hasSlots = true;
        this.slotIds.forEach((slot) => {
          slot.replaceAll('"', "");
        });
      }
      var slotPositions = this.slotPositions;
      var slotIds = this.slotIds;
      var slotWidths = this.slotWidths;
      var trackType;
      var apiOptions = {};

      apiOptions.products = {
        facets: ["*"],
        fields: [
          "name",
          "price",
          "listPrice",
          "url",
          "imageUrl",
          "alternateImageUrls",
          "customFields.key",
          "customFields.value",
          "categories",
          "tags1",
        ],
        size: collection_size,
        from: collection_from,
        preFilter: this.collectionFilter,
        sort: sortArray,
      };
      if (this.searchTerm != "") {
        apiOptions.query = this.searchTerm;
        trackType = "serp";
      } else {
        apiOptions.products.categoryId = this.collectionId;
        trackType = "category";
      }
      nostojs((api) => {
        api
          .search(apiOptions, {
            track: trackType,
            redirect: true,
          })
          .then((response) => {
            var products = response.products.hits;
            if(collection_direction == 'before') {
              products.reverse();
            }
            var container = this.querySelector("#main-collection-product-grid");
            var previousHeight = container.scrollHeight;
            var previousScrollY = window.scrollY;

            if (collection_reset) {
              container.innerHTML = "";
            }
            var currentPage = Math.ceil((products.length + response.products.from) / collection_size);
            var sIndex = collection_direction == 'before' ? collection_from + collection_size : collection_from;
            products.forEach((nostoItem, index) => {
              if(collection_direction == 'before') {
                if(index > 0) {
                  sIndex -= 1;
                }
              } else {
                sIndex = sIndex + 1;
              }
              var injectSlot = false;
              var slotIndex = 0;
              var slotNostoID = null;
              var slotNostoWidth = 1;
              if (hasSlots) {
                slotPositions.forEach((position) => {
                  if (position == sIndex) {
                    injectSlot = true;
                    slotNostoID = slotIds[slotIndex];
                    if (slotWidths) {
                      slotNostoWidth = slotWidths[slotIndex];
                    }
                  }
                  slotIndex = slotIndex + 1;
                });
              }
              if (injectSlot) {
                var slot =
                  '<li class="collection-grid__item slot-width-' +
                  slotNostoWidth +
                  '"><div class="slot-placeholder"><div class="nosto_element" id="' +
                  slotNostoID +
                  '"></div></div></li>';
                container.insertAdjacentHTML("beforeend", slot);
              }
              var metafields = [];
              nostoItem.page = currentPage;
              nostoItem.cardPosition = `P${currentPage}C${sIndex}`
              nostoItem.videoDesktop = null;
              nostoItem.videoMobile = null;
              nostoItem.videoUnisex = null;
              nostoItem.videoUnisex_womens_image_position = null;
              nostoItem.videoUnisex_mens_image_position = null;
              nostoItem.videoUnisex_mens_plp_desktop_video = null;
              nostoItem.videoUnisex_mens_plp_mobile_video = null;

              nostoItem.customFields.forEach((field, i) => {
                if (field.key == "images-image_icon") {
                  metafields.push(field);
                }
                if (field.key == "video-plp_desktop_video") {
                  var video = JSON.parse(field.value);
                  nostoItem.videoDesktop = video[0].src;
                }
                if (field.key == "video-plp_mobile_video") {
                  var video = JSON.parse(field.value);
                  nostoItem.videoMobile = video[0].src;
                }
                if (field.key == "video-unisex") {
                  nostoItem.videoUnisex = field.value;
                }
                if (field.key == "video-unisex_womens_image_position") {
                  nostoItem.videoUnisex_womens_image_position = parseInt(
                    field.value
                  );
                }
                if (field.key == "video-unisex_womens_hover_image_position") {
                  nostoItem.videoUnisex_womens_hover_image_position = parseInt(
                    field.value
                  );
                }
                if (field.key == "video-unisex_mens_image_position") {
                  nostoItem.videoUnisex_mens_image_position = parseInt(
                    field.value
                  );
                }
                if (field.key == "video-unisex_mens_hover_image_position") {
                  nostoItem.videoUnisex_mens_hover_image_position = parseInt(
                    field.value
                  );
                }
                if (field.key == "video-unisex_mens_plp_dekstop_video") {
                  var video = JSON.parse(field.value);
                  nostoItem.videoUnisex_mens_plp_desktop_video = video[0].src;
                }
                if (field.key == "video-unisex_mens_plp_mobile_video") {
                  var video = JSON.parse(field.value);
                  nostoItem.videoUnisex_mens_plp_mobile_video = video[0].src;
                }
              });
              nostoItem.metafields = metafields;
              if (document.location.pathname.indexOf("/collections/") > -1) {
                nostoItem.url = nostoItem.url.replace(
                  "/products",
                  document.location.pathname + "/products"
                );
              }
              delete nostoItem.customFields;
              var categories = nostoItem.categories?.map((category) =>
                category.toLowerCase()
              );
              var collectionTitle = "";
              categories?.forEach((category) => {
                if (category.startsWith("collection - ")) {
                  collectionTitle = category;
                }
              });
              var singleProd = "false";
              var collectionHandle = "";
              if (collectionTitle != "") {
                var collectionHandle = collectionTitle
                  .replaceAll(" - ", "-")
                  .replaceAll(": ", "-")
                  .replaceAll(" & ", "-")
                  .replaceAll(" ", "-")
                  .replaceAll("/", "-")
                  .replaceAll('"', "")
                  .replaceAll("'", "")
                  .replaceAll(".", "-")
                  .replaceAll("--", "-");
                if (this.collectionArray.indexOf(collectionHandle) === -1) {
                  this.collectionArray.push(collectionHandle);
                }
              } else {
                singleProd = "true";
              }
              var buildItem =
                '<li class="collection-grid__item slot-' +
                sIndex +
                '"><nosto-collection-item data-type="' +
                trackType +
                '" data-collection="false" data-international="' +
                this.international +
                '" data-collection-handle="' +
                collectionHandle +
                '" data-single-product="' +
                singleProd +
                '" data-gendered="' +
                this.gendered +
                '">';
              buildItem +=
                '<data class="nosto-data" style="display:none;">' +
                JSON.stringify(nostoItem) +
                "</data>";
              buildItem += "</nosto-collection-item></li>";
              container.insertAdjacentHTML(collection_direction == 'before' ? "afterbegin" : "beforeend", buildItem);
            });

            if(collection_direction !== "before" && !collection_reset) {
              var urlObject = new URL(document.location.href);
              urlObject.searchParams.set('page', Math.ceil(currentPage));
              history.replaceState(null, null, urlObject.toString())
            }
            var pagination = this.querySelector("#cc-pagination");
            var previousButton = this.querySelector('[data-load-previous]');
            var countP = products.length + response.products.from;
            var totalP = response.products.total;
            var previousFrom = (Math.ceil(countP / collection_size) - 2) * collection_size;

            if(collection_direction !== 'before') {
              // set forward pagination, only alter this when navigating forward
              pagination.querySelector(".collection-product-count").innerHTML =
                "Showing " + countP + " of " + totalP;
              if (countP != totalP) {
                pagination
                  .querySelector(".collection-paginate")
                  .classList.add("visible");

                  pagination
                    .querySelector(".collection-paginate a")
                    .setAttribute("data-from", countP);
              } else {
                pagination
                  .querySelector(".collection-paginate")
                  .classList.remove("visible");
              }
            }

            // set backwards pagination
            if(previousButton) {
              if(previousFrom < 0) {
                if(this.intersectionObserver) {
                  this.intersectionObserver.disconnect();
                }
                if(previousButton) {
                  previousButton.remove();
                }
              } else {
                previousButton
                .setAttribute('data-from', previousFrom);
                if(previousButton.dataset.isObserved !== "true") {
                  this.intersectionObserver.observe(previousButton);
                  previousButton.setAttribute('data-is-observed', "true");
                }
              }
            }
            if (this.hasUrlFilters == false) {
              this.querySelector("#ss-skeleton-grid").style.display = "none";
            }
            this.getCollectionData();
            var allowedFacets = ["Category", "Size", "Color"];

            if (this.getAttribute("exposed-filters")) {
              let filters = this.getAttribute("exposed-filters").split(", ");
              allowedFacets.push(...filters);
            }

            if (this.getAttribute("filter-gender") == "true") {
              allowedFacets.push("Gender");
            }
            if (this.getAttribute("filter-fit") == "true") {
              allowedFacets.push("Fit");
            }
            if (this.getAttribute("filter-inseam") == "true") {
              allowedFacets.push("Inseam");
            }
            var filteredFacets = [];
            response.products.facets.forEach((facet) => {
              if (allowedFacets.includes(facet.name)) {
                filteredFacets.push(facet);
              }
            });
            if (this.collectionFilter.length == 0) {
              this.createFilters(filteredFacets);
            } else {
              this.updateFilterOptions(filteredFacets);
              if (
                this.querySelector(
                  ".collection-active-filters__results-count span"
                ) != null
              ) {
                this.querySelector(
                  ".collection-active-filters__results-count span"
                ).innerHTML = totalP;
              }
            }
            if (this.hasUrlFilters) {
              this.getUrlFilters();
            }

            api
              .defaultSession()
              .setResponseMode("HTML")
              .viewFrontPage()
              .setPlacements(api.placements.getPlacements())
              .load()
              .then((response) => {
                api.placements.injectCampaigns(response.recommendations);
              });

            if(this.urlObject.hash != "") {
              const productCard = this.querySelector(this.urlObject.hash);
              productCard.scrollIntoView({
                block: "center",
                inline: "center"
              })
              this.urlObject.hash = "";
              history.replaceState(null, null, this.urlObject.toString());
            }

            if(collection_direction == "before") {
              console.log('recalculating the top');
              var newHeight = container.scrollHeight;
              var heightDiff = newHeight - previousHeight;
              console.log(previousScrollY + heightDiff);
              window.scrollTo({
                top: previousScrollY + heightDiff,
                behavior: 'instant'
              });
            }
          });
      });
    }
    getCollectionData() {
      var mainEl = this;
      this.collectionArray.forEach((collection) => {
        fetch("/collections/" + collection + "?view=nosto-api")
          .then((response) => {
            if (!response.ok) {
              throw new Error("Collection Not found: " + collection);
            }
            return response.json();
          })
          .then((data) => {
            var toSave = data;
            mainEl.collectionData[collection] = toSave;
            collectionData[collection] = toSave;
            var markAvailable = mainEl.querySelectorAll(
              '[data-collection-handle="' + collection + '"]'
            );
            markAvailable.forEach((mark) => {
              mark.setAttribute("data-collection", "true");
            });
          })
          .catch((error) => {
            console.error(error);
            var markSingle = mainEl.querySelectorAll(
              '[data-collection-handle="' + collection + '"]'
            );
            markSingle.forEach((mark) => {
              mark.setAttribute("data-single-product", "true");
            });
          });
      });
    }
    createFilters(facets) {
      const hiddenFilters =
        this.getAttribute("hidden-filters")?.split(", ") || [];
      var dropdownsDHtml = "";
      var dropdownsMHtml = "";
      var sizeValArray = [];
      facets.forEach((facet) => {
        if (facet.name == "Size") {
          var size_OS = {
            value: "OS",
            ava: false,
            count: 0,
            selected: false,
          };
          var size_XS = {
            value: "XS",
            ava: false,
            count: 0,
            selected: false,
          };
          var size_S = {
            value: "S",
            ava: false,
            count: 0,
            selected: false,
          };
          var size_M = {
            value: "M",
            ava: false,
            count: 0,
            selected: false,
          };
          var size_L = {
            value: "L",
            ava: false,
            count: 0,
            selected: false,
          };
          var size_XL = {
            value: "XL",
            ava: false,
            count: 0,
            selected: false,
          };
          var size_XXL = {
            value: "XXL",
            ava: false,
            count: 0,
            selected: false,
          };
          var size_XXXL = {
            value: "XXXL",
            ava: false,
            count: 0,
            selected: false,
          };
          facet.data.forEach((fSize) => {
            if (fSize.value == "OS") {
              size_OS.ava = true;
              size_OS.count = fSize.count;
              size_OS.selected = fSize.selected;
            } else if (fSize.value == "XS") {
              size_XS.ava = true;
              size_XS.count = fSize.count;
              size_XS.selected = fSize.selected;
            } else if (fSize.value == "S") {
              size_S.ava = true;
              size_S.count = fSize.count;
              size_S.selected = fSize.selected;
            } else if (fSize.value == "M") {
              size_M.ava = true;
              size_M.count = fSize.count;
              size_M.selected = fSize.selected;
            } else if (fSize.value == "L") {
              size_L.ava = true;
              size_L.count = fSize.count;
              size_L.selected = fSize.selected;
            } else if (fSize.value == "XL") {
              size_XL.ava = true;
              size_XL.count = fSize.count;
              size_XL.selected = fSize.selected;
            } else if (fSize.value == "XXL") {
              size_XXL.ava = true;
              size_XXL.count = fSize.count;
              size_XXL.selected = fSize.selected;
            } else if (fSize.value == "XXXL") {
              size_XXXL.ava = true;
              size_XXXL.count = fSize.count;
              size_XXXL.selected = fSize.selected;
            } else {
              sizeValArray.push(fSize);
            }
          });
          if (size_OS.ava == true) {
            sizeValArray.push(size_OS);
          }
          if (size_XS.ava == true) {
            sizeValArray.push(size_XS);
          }
          if (size_S.ava == true) {
            sizeValArray.push(size_S);
          }
          if (size_M.ava == true) {
            sizeValArray.push(size_M);
          }
          if (size_L.ava == true) {
            sizeValArray.push(size_L);
          }
          if (size_XL.ava == true) {
            sizeValArray.push(size_XL);
          }
          if (size_XXL.ava == true) {
            sizeValArray.push(size_XXL);
          }
          if (size_XXXL.ava == true) {
            sizeValArray.push(size_XXXL);
          }
          facet.data = sizeValArray;
        }
      });
      facets.forEach((facet) => {
        if (facet.type == "terms") {
          let isHidden = hiddenFilters.includes(facet.name);
          this.collectionFilter.push({
            field: facet.field,
            value: [],
          });
          dropdownsDHtml += `<details class="collection-filter disclosure-has-popup" data-filter="" data-index="1" ${
            isHidden ? 'style="display:none !important"' : ""
          }>`;
          dropdownsDHtml +=
            '<summary class="collection-filter__button" data-filter-button="">' +
            facet.name;
          dropdownsDHtml +=
            ' <span></span><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Caret Icon</title>';
          dropdownsDHtml +=
            '<path d="M6.83203 13.416L1.21745 6.99935L6.83203 0.582683" stroke="currentColor"></path>';
          dropdownsDHtml += "</svg>";
          dropdownsDHtml += "</summary>";
          dropdownsDHtml += '<div class="collection-filter__options">';
          dropdownsDHtml +=
            '<ul class="collection-filter__options__list" data-filter-field="' +
            facet.field +
            '">';

          dropdownsMHtml += `<li class="collection-filters-drawer__list__item" data-filter="" data-index="mobile-1" ${
            isHidden ? 'style="display: none !important"' : ""
          }>`;
          dropdownsMHtml +=
            '<p class="collection-filters-drawer__list__heading p2 p2--fixed">' +
            facet.name +
            "</p>";
          dropdownsMHtml +=
            '<ul class="collection-filters-drawer__options" data-filter-field="' +
            facet.field +
            '">';
          facet.data.forEach((fOption, i) => {
            var half = "collection-filters-drawer__options__item--half";
            dropdownsDHtml +=
              '<li class="collection-filter__options__item show" data-filter-value="' +
              fOption.value +
              '">';
            dropdownsDHtml +=
              '<input type="checkbox" data-category="' +
              facet.name +
              '" name="' +
              facet.field +
              '" value="' +
              fOption.value +
              '" id="Filter-' +
              facet.id +
              "-" +
              i +
              '">';
            dropdownsDHtml +=
              '<label for="Filter-' +
              facet.id +
              "-" +
              i +
              '" class="collection-filter__option p2">';
            dropdownsDHtml +=
              fOption.value +
              ' <span class="collection-filter__option__count">(' +
              fOption.count +
              ")</span>";
            dropdownsDHtml += "</label>";
            dropdownsDHtml += "</li>";

            dropdownsMHtml +=
              '<li class="collection-filters-drawer__options__item collection-filters-drawer__options__item--half show" data-filter-value="' +
              fOption.value +
              '">';
            dropdownsMHtml +=
              '<input type="checkbox"  data-category="' +
              facet.name +
              '" name="' +
              facet.field +
              '" value="' +
              fOption.value +
              '" id="Filter-Mobile-' +
              facet.id +
              "-" +
              i +
              '">';
            dropdownsMHtml +=
              '<label for="Filter-Mobile-' +
              facet.id +
              "-" +
              i +
              '" class="collection-filters-drawer__option p2">';
            dropdownsMHtml +=
              fOption.value +
              ' <span class="collection-filters-drawer__option__count">(' +
              fOption.count +
              ")</span>";
            dropdownsMHtml += "</label>";
            dropdownsMHtml += "</li>";
          });
          dropdownsDHtml += "</ul>";
          dropdownsDHtml += "</div>";
          dropdownsDHtml += "</details>";

          dropdownsMHtml += "</ul></li>";
        }
      });
      var filterHtml = "<collection-filters-form>";
      filterHtml +=
        '<div class="collection-nav-spacer" data-collection-nav-spacer=""></div>';
      filterHtml += '<nav class="collection-nav p2" data-collection-nav="">';
      filterHtml += '<div class="collection-nav__wrapper">';
      filterHtml += '<div class="collection-nav__item">';
      filterHtml += '<div class="collection-nav__item__inner">';
      filterHtml += '<details class="collection-filters-mobile">';
      filterHtml +=
        '<summary class="collection-filters-mobile__button" data-filters-mobile-trigger="">';
      filterHtml +=
        '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none"><title>Filter Icon</title><path d="M1.926 11.8378H2.05673L2.0899 11.7114C2.47615 10.2391 3.8061 9.14513 5.4 9.14513C6.9939 9.14513 8.32385 10.2391 8.7101 11.7114L8.74327 11.8378H8.874H17.8306V13.2941H8.874H8.74327L8.7101 13.4205C8.32385 14.8929 6.9939 15.9868 5.4 15.9868C3.8061 15.9868 2.47615 14.8929 2.0899 13.4205L2.05673 13.2941H1.926H0.169444V11.8378H1.926ZM15.9101 2.7357L15.9433 2.86215H16.074H17.8306V4.3184H16.074H15.9433L15.9101 4.44485C15.5239 5.91719 14.1939 7.01111 12.6 7.01111C11.0061 7.01111 9.67615 5.91719 9.2899 4.44485L9.25673 4.3184H9.126H0.169444V2.86215H9.126H9.25673L9.2899 2.7357C9.67615 1.26336 11.0061 0.169444 12.6 0.169444C14.1939 0.169444 15.5239 1.26336 15.9101 2.7357ZM3.43056 12.566C3.43056 13.6473 4.31685 14.5305 5.4 14.5305C6.48315 14.5305 7.36944 13.6473 7.36944 12.566C7.36944 11.4846 6.48315 10.6014 5.4 10.6014C4.31685 10.6014 3.43056 11.4846 3.43056 12.566ZM10.6306 3.59027C10.6306 4.67161 11.5169 5.55486 12.6 5.55486C13.6831 5.55486 14.5694 4.67161 14.5694 3.59027C14.5694 2.50894 13.6831 1.62569 12.6 1.62569C11.5169 1.62569 10.6306 2.50894 10.6306 3.59027Z" fill="black" stroke="black" stroke-width="0.338889"/></svg>';
      filterHtml +=
        'Filter & Sort <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none"><title>Icon Caret</title><path d="M0.599609 1.25L6.69961 6.00962L12.7996 1.25" stroke="black" stroke-width="0.938462"/></svg></summary>';
      filterHtml += '<div class="collection-filters-drawer">';
      filterHtml += '<div class="collection-filters-drawer__wrapper">';
      filterHtml += '<div class="collection-filters-drawer__head">';
      filterHtml += '<p class="collection-filters-drawer__title h6">Filter</p>';
      filterHtml += '<div class="collection-filters-drawer__head__actions">';
      filterHtml +=
        '<a class="underlined-link underlined-link--small collection-filters-drawer__head__clear" href="javascript:void(0);" data-filter-remove="" title="Clear All">';
      filterHtml +=
        '<span>Clear All</span></a><button class="collection-filters-drawer__head__close" data-filters-mobile-close="" aria-label="Close Filters"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">';
      filterHtml += "<title>Close filters</title>"
      filterHtml +=
        '<path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">';
      filterHtml += "</path></svg>";
      filterHtml += "</button>";
      filterHtml += "</div>";
      filterHtml += "</div>";
      filterHtml +=
        '<div class="collection-filters-drawer__body" data-filters-mobile-body="">';
      filterHtml += '<div id="mobile-sort-by">';
      filterHtml += "<p>Sort By</p>";
      filterHtml += "<ul>";
      filterHtml +=
        '<li><input type="radio" id="m-r-1" name="m-sort" value="" data-sort="" checked><label for="m-r-1">Most Popular</label></li>';
      filterHtml +=
        '<li><input type="radio" id="m-r-2" name="m-sort" value="published" data-sort="desc"><label for="m-r-2">Newest</label></li>';
      filterHtml +=
        '<li><input type="radio" id="m-r-3" name="m-sort" value="price" data-sort="asc"><label for="m-r-3">Price: Low to High</label></li>';
      filterHtml +=
        '<li><input type="radio" id="m-r-4" name="m-sort" value="price" data-sort="desc"><label for="m-r-4">Price: High to Low</label></li>';
      filterHtml += "</ul>";
      filterHtml += "</div>";
      filterHtml += '<form data-filters-form="" id="FiltersFormMobile">';
      filterHtml += '<input type="hidden" name="sort_by" value="">';
      filterHtml += '<input type="hidden" name="page" value="1">';
      filterHtml += '<ul class="collection-filters-drawer__list">';
      filterHtml += dropdownsMHtml;
      filterHtml += "</ul>";
      filterHtml += "</form>";
      filterHtml += "</div>";
      filterHtml += '<div class="collection-filters-drawer__foot">';
      filterHtml +=
        '<button class="button button--full-width collection-filters-drawer__foot__button" type="button" data-filters-mobile-close="">';
      filterHtml += "<span>View Results</span></button></div>";
      filterHtml += "</div>";
      filterHtml += "</div>";
      filterHtml += "</details>";
      filterHtml += '<div class="collection-filters">';
      filterHtml += '<form data-filters-form="" id="FiltersForm">';
      filterHtml += '<input type="hidden" name="sort_by" value="">';
      filterHtml += '<input type="hidden" name="page" value="1">';
      filterHtml += dropdownsDHtml;
      filterHtml += "</form>";
      filterHtml += "</div>";
      filterHtml += "</div>";
      filterHtml += "</div>";
      filterHtml += '<div class="collection-nav__item">';
      filterHtml += '<div class="collection-nav__item__inner">';
      filterHtml += '<div class="collection-sort">';
      filterHtml +=
        '<label for="CollectionSortBy" class="collection-sort__label">';
      filterHtml +=
        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none"><title>sort icon</title>';
      filterHtml +=
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.5 1.63285C21.5 1.82329 21.421 2.00593 21.2803 2.14059C21.1397 2.27525 20.9489 2.3509 20.75 2.3509H0.75C0.551088 2.3509 0.360322 2.27525 0.21967 2.14059C0.0790177 2.00593 0 1.82329 0 1.63285C0 1.44241 0.0790177 1.25977 0.21967 1.12511C0.360322 0.990447 0.551088 0.914795 0.75 0.914795H20.75C20.9489 0.914795 21.1397 0.990447 21.2803 1.12511C21.421 1.25977 21.5 1.44241 21.5 1.63285ZM18.5 6.41988C18.5 6.61032 18.421 6.79296 18.2803 6.92762C18.1397 7.06228 17.9489 7.13794 17.75 7.13794H3.75C3.55109 7.13794 3.36032 7.06228 3.21967 6.92762C3.07902 6.79296 3 6.61032 3 6.41988C3 6.22944 3.07902 6.0468 3.21967 5.91214C3.36032 5.77748 3.55109 5.70183 3.75 5.70183H17.75C17.9489 5.70183 18.1397 5.77748 18.2803 5.91214C18.421 6.0468 18.5 6.22944 18.5 6.41988ZM15.5 11.2069C15.5 11.3974 15.421 11.58 15.2803 11.7147C15.1397 11.8493 14.9489 11.925 14.75 11.925H6.75C6.55109 11.925 6.36032 11.8493 6.21967 11.7147C6.07902 11.58 6 11.3974 6 11.2069C6 11.0165 6.07902 10.8338 6.21967 10.6992C6.36032 10.5645 6.55109 10.4889 6.75 10.4889H14.75C14.9489 10.4889 15.1397 10.5645 15.2803 10.6992C15.421 10.8338 15.5 11.0165 15.5 11.2069Z" fill="#111111"/>';
      filterHtml += "</svg>";
      filterHtml += "Sort:";
      filterHtml += "</label>";
      filterHtml += '<div class="collection-sort__wrapper">';
      filterHtml +=
        '<select class="collection-sort__select" id="CollectionSortBy" aria-describedby="a11y-refresh-page-message"><option value="" data-sort="">Most Popular</option><option value="published" data-sort="desc">Newest</option><option value="price" data-sort="asc">Price: Low to High</option><option value="price" data-sort="desc">Price: High to Low</option></select>';
      filterHtml +=
        '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><title>icon caret</title>';
      filterHtml +=
        '<path d="M6.83203 13.416L1.21745 6.99935L6.83203 0.582683" stroke="currentColor"></path>';
      filterHtml += "</svg>";
      filterHtml += "</div>";
      filterHtml += "</div>";
      filterHtml += '<div class="collection-grid-size">';
      var grid3Active = "";
      var grid4Active = "active";
      if (this.gridSize == "3") {
        grid3Active = "active";
        grid4Active = "";
      }
      filterHtml +=
        '<button  id="grid-3" class="' +
        grid3Active +
        '" aria-label="Set layout three across on desktop and one across on mobile"><span class="bar"></span><span class="bar"></span><span class="bar"></span></button>';
      filterHtml +=
        '<button id="grid-4" class="' +
        grid4Active +
        '" aria-label="Set layout four across on desktop and two across on mobile"><span class="bar"></span><span class="bar"></span><span class="bar"></span><span class="bar"></span></button>';
      filterHtml += "</div>";
      filterHtml += "</div>";
      filterHtml += "</div>";
      filterHtml += "</div>";
      filterHtml += "</nav>";
      filterHtml +=
        '<nav class="collection-active-filters" data-active-filters=""></nav>';
      filterHtml += "</collection-filters-form>";
      this.querySelector(".collection-grid").insertAdjacentHTML(
        "beforebegin",
        filterHtml
      );
      this.collectionFilterOptions = facets;
      this.filterEvents();
    }
    filterState(fInput, fState = null) {
      var fName = fInput.getAttribute("data-category");
      var fValue = fInput.getAttribute("value");
      if (fState == null) {
        fState = fInput.checked;
      }
      this.collectionFilterOptions.forEach((item) => {
        if (item.name == fName) {
          item.data.forEach((itemVal) => {
            if (itemVal.value == fValue) {
              itemVal.selected = fState;
            }
          });
        }
      });
    }
    filterEvents() {
      this.querySelectorAll(".collection-filters input").forEach((fInput) => {
        fInput.addEventListener("change", (event) => {
          this.filterState(fInput);
          this.filterCollection();
        });
      });
      this.querySelectorAll("#FiltersFormMobile input").forEach((fInput) => {
        fInput.addEventListener("change", (event) => {
          this.filterState(fInput);
          this.filterCollection();
        });
      });
      this.querySelector("[data-filters-mobile-close]").addEventListener(
        "click",
        () => {
          this.querySelector(".collection-filters-mobile").removeAttribute(
            "open"
          );
          if (document.querySelector("#gorgias-chat-container")) {
            document.querySelector("#gorgias-chat-container").style.display =
              "block";
          }
        }
      );
      this.querySelector("#grid-3").addEventListener("click", (el) => {
        this.querySelector("#grid-3").classList.add("active");
        this.querySelector("#grid-4").classList.remove("active");
        this.querySelector("#main-collection-product-grid").classList.add(
          "collection-grid__list--3"
        );
        this.querySelector("#main-collection-product-grid").classList.remove(
          "collection-grid__list--4"
        );
        cc_setCookie("ok_collection_grid", "3", 365);
      });
      this.querySelector("#grid-4").addEventListener("click", (el) => {
        this.querySelector("#grid-4").classList.add("active");
        this.querySelector("#grid-3").classList.remove("active");
        this.querySelector("#main-collection-product-grid").classList.add(
          "collection-grid__list--4"
        );
        this.querySelector("#main-collection-product-grid").classList.remove(
          "collection-grid__list--3"
        );
        cc_setCookie("ok_collection_grid", "4", 365);
      });
      this.querySelector(
        ".collection-filters-drawer__head__clear"
      ).addEventListener("click", () => {
        this.querySelectorAll("#FiltersFormMobile input").forEach((option) => {
          option.checked = false;
          this.filterState(option);
        });
        this.filterCollection();
        this.querySelector(".collection-filters-mobile").removeAttribute(
          "open"
        );
        if (document.querySelector("#gorgias-chat-container")) {
          document.querySelector("#gorgias-chat-container").style.display =
            "block";
        }
      });
      this.querySelector(".collection-filters-mobile__button").addEventListener(
        "click",
        () => {
          if (document.querySelector("#gorgias-chat-container")) {
            document.querySelector("#gorgias-chat-container").style.display =
              "none";
          }
        }
      );
      this.querySelector(
        ".collection-filters-drawer__foot__button"
      ).addEventListener("click", () => {
        this.querySelector(".collection-filters-mobile").removeAttribute(
          "open"
        );
        if (document.querySelector("#gorgias-chat-container")) {
          document.querySelector("#gorgias-chat-container").style.display =
            "block";
        }
      });
      this.querySelector("#CollectionSortBy").addEventListener("change", () => {
        var theSelect = this.querySelector("#CollectionSortBy");
        var theOption = theSelect.options[theSelect.selectedIndex];
        var dataSort = theOption.getAttribute("data-sort");
        var dataValue = theOption.getAttribute("value");
        this.querySelector(
          '#mobile-sort-by input[data-sort="' +
            dataSort +
            '"][value="' +
            dataValue +
            '"]'
        ).checked = true;
        this.getNostoCollection(0, true);
      });
      this.querySelectorAll("#mobile-sort-by input").forEach((radio) => {
        radio.addEventListener("click", (el) => {
          var dataSort = radio.getAttribute("data-sort");
          var dataValue = radio.getAttribute("value");
          this.querySelector(
            '#CollectionSortBy option[data-sort="' +
              dataSort +
              '"][value="' +
              dataValue +
              '"]'
          ).selected = "selected";
          this.getNostoCollection(0, true);
        });
      });
      if (this.visualFilters == "true") {
        this.querySelectorAll("#nosto-visual-filters .visual-filter").forEach(
          (vFilter) => {
            if (vFilter.querySelector("video")) {
              vFilter
                .querySelector("video")
                .addEventListener("mouseover", function () {
                  if (
                    vFilter.querySelector("video").getAttribute("data-src") !=
                    ""
                  ) {
                    vFilter.querySelector("video").innerHTML =
                      '<source src="' +
                      vFilter.querySelector("video").getAttribute("data-src") +
                      '" type="video/mp4">';
                    vFilter.querySelector("video").setAttribute("data-src", "");
                  } else {
                    vFilter.querySelector("video").play();
                  }
                });
              vFilter
                .querySelector("video")
                .addEventListener("mouseleave", function () {
                  vFilter.querySelector("video").load();
                  vFilter.querySelector("video").pause();
                });
            }
            vFilter.addEventListener("click", (event) => {
              if (vFilter.classList.contains("active")) {
                vFilter.classList.remove("active");
                this.filterState(vFilter, false);
              } else {
                vFilter.classList.add("active");
                this.filterState(vFilter, true);
              }
              this.filterCollection();
            });
          }
        );
      }
    }
    filterCollection() {
      const hiddenFitlers = this.getAttribute("hidden-filters");
      var filterCount = 0;
      var itemHtml = "";
      var display = false;
      for (let i = 0; i < this.collectionFilter.length; i++) {
        this.collectionFilter[i].value = [];
        this.collectionFilterOptions[i].data.forEach((item) => {
          if (item.selected == true) {
            this.collectionFilter[i].value.push(item.value);
            if (!hiddenFitlers.includes(this.collectionFilterOptions[i].name)) {
              filterCount = filterCount + 1;
              display = true;

              itemHtml += '<li class="collection-active-filters__item">';
              itemHtml +=
                '<a class="collection-active-filters__link caption color-ink ss__pointer" value="' +
                item.value +
                '" data-category="' +
                this.collectionFilterOptions[i].name +
                '">' +
                this.collectionFilterOptions[i].name +
                ": " +
                item.value +
                " ";
              itemHtml +=
                '<svg aria-hidden="true" focusable="false" role="presentation" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.48627 9.32917L2.82849 3.67098" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.88539 9.38504L8.42932 3.61524" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
              itemHtml += "</a>";
              itemHtml += "</li>";
            }
          }
          this.querySelectorAll(
            'input[name="' +
              this.collectionFilter[i].field +
              '"][value="' +
              item.value +
              '"]'
          ).forEach((input) => {
            input.checked = item.selected;
          });
        });
        var parent = this.querySelector(
          '.collection-filters [data-filter-field="' +
            this.collectionFilter[i].field +
            '"]'
        ).parentElement.previousSibling;
        if (this.collectionFilter[i].value.length > 0) {
          parent.querySelector("span").innerHTML =
            "(" + this.collectionFilter[i].value.length + ")";
        } else {
          parent.querySelector("span").innerHTML = "";
        }
      }
      if (filterCount > 0) {
        this.querySelector(".collection-filters-mobile__button").innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none"><path d="M1.926 11.8378H2.05673L2.0899 11.7114C2.47615 10.2391 3.8061 9.14513 5.4 9.14513C6.9939 9.14513 8.32385 10.2391 8.7101 11.7114L8.74327 11.8378H8.874H17.8306V13.2941H8.874H8.74327L8.7101 13.4205C8.32385 14.8929 6.9939 15.9868 5.4 15.9868C3.8061 15.9868 2.47615 14.8929 2.0899 13.4205L2.05673 13.2941H1.926H0.169444V11.8378H1.926ZM15.9101 2.7357L15.9433 2.86215H16.074H17.8306V4.3184H16.074H15.9433L15.9101 4.44485C15.5239 5.91719 14.1939 7.01111 12.6 7.01111C11.0061 7.01111 9.67615 5.91719 9.2899 4.44485L9.25673 4.3184H9.126H0.169444V2.86215H9.126H9.25673L9.2899 2.7357C9.67615 1.26336 11.0061 0.169444 12.6 0.169444C14.1939 0.169444 15.5239 1.26336 15.9101 2.7357ZM3.43056 12.566C3.43056 13.6473 4.31685 14.5305 5.4 14.5305C6.48315 14.5305 7.36944 13.6473 7.36944 12.566C7.36944 11.4846 6.48315 10.6014 5.4 10.6014C4.31685 10.6014 3.43056 11.4846 3.43056 12.566ZM10.6306 3.59027C10.6306 4.67161 11.5169 5.55486 12.6 5.55486C13.6831 5.55486 14.5694 4.67161 14.5694 3.59027C14.5694 2.50894 13.6831 1.62569 12.6 1.62569C11.5169 1.62569 10.6306 2.50894 10.6306 3.59027Z" fill="black" stroke="black" stroke-width="0.338889"/></svg> Filter & Sort (' +
          filterCount +
          ') <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none"><path d="M0.599609 1.25L6.69961 6.00962L12.7996 1.25" stroke="black" stroke-width="0.938462"/></svg>';
      } else {
        this.querySelector(".collection-filters-mobile__button").innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none"><path d="M1.926 11.8378H2.05673L2.0899 11.7114C2.47615 10.2391 3.8061 9.14513 5.4 9.14513C6.9939 9.14513 8.32385 10.2391 8.7101 11.7114L8.74327 11.8378H8.874H17.8306V13.2941H8.874H8.74327L8.7101 13.4205C8.32385 14.8929 6.9939 15.9868 5.4 15.9868C3.8061 15.9868 2.47615 14.8929 2.0899 13.4205L2.05673 13.2941H1.926H0.169444V11.8378H1.926ZM15.9101 2.7357L15.9433 2.86215H16.074H17.8306V4.3184H16.074H15.9433L15.9101 4.44485C15.5239 5.91719 14.1939 7.01111 12.6 7.01111C11.0061 7.01111 9.67615 5.91719 9.2899 4.44485L9.25673 4.3184H9.126H0.169444V2.86215H9.126H9.25673L9.2899 2.7357C9.67615 1.26336 11.0061 0.169444 12.6 0.169444C14.1939 0.169444 15.5239 1.26336 15.9101 2.7357ZM3.43056 12.566C3.43056 13.6473 4.31685 14.5305 5.4 14.5305C6.48315 14.5305 7.36944 13.6473 7.36944 12.566C7.36944 11.4846 6.48315 10.6014 5.4 10.6014C4.31685 10.6014 3.43056 11.4846 3.43056 12.566ZM10.6306 3.59027C10.6306 4.67161 11.5169 5.55486 12.6 5.55486C13.6831 5.55486 14.5694 4.67161 14.5694 3.59027C14.5694 2.50894 13.6831 1.62569 12.6 1.62569C11.5169 1.62569 10.6306 2.50894 10.6306 3.59027Z" fill="black" stroke="black" stroke-width="0.338889"/></svg> Filter & Sort <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none"><path d="M0.599609 1.25L6.69961 6.00962L12.7996 1.25" stroke="black" stroke-width="0.938462"/></svg>';
      }
      var activeHtml = '<nav class="collection-active-filters">';
      activeHtml += '<div class="collection-active-filters__wrapper">';
      activeHtml += '<div class="collection-active-filters__main">';
      activeHtml += '<ul class="collection-active-filters__list">';
      activeHtml += itemHtml;
      activeHtml += "</ul>";
      activeHtml +=
        '<a href="javascript:void(0);" class="underlined-link collection-active-filters__clear" data-filter-remove="" title="Clear All">';
      activeHtml += "<span>Clear All</span>";
      activeHtml += "</a>";
      activeHtml += "</div>";
      activeHtml +=
        '<div class="collection-active-filters__results-count caption color-subdued"><span></span> Results</div>';
      activeHtml += "</div>";
      activeHtml += "</nav>";
      if (this.querySelector(".collection-active-filters") != null) {
        this.querySelector(".collection-active-filters").remove();
      }
      if (display) {
        this.querySelector("[data-collection-nav]").insertAdjacentHTML(
          "afterend",
          activeHtml
        );

        this.querySelectorAll(".collection-active-filters__link").forEach(
          (link) => {
            link.addEventListener("click", (event) => {
              this.filterState(link, false);
              this.filterCollection();
            });
          }
        );
        this.querySelector(
          ".collection-active-filters__clear"
        ).addEventListener("click", (event) => {
          this.querySelectorAll(".collection-filters input").forEach(
            (option) => {
              option.checked = false;
              this.filterState(option);
            }
          );
          this.filterCollection();
        });
      }
      this.getNostoCollection(0, true);
    }
    updateFilterOptions(newFacets) {
      newFacets.forEach((facet) => {
        if (facet.type == "terms") {
          var currentOptionsArray = this.querySelectorAll(
            '.collection-filters [data-filter-field="' + facet.field + '"] li'
          );
          currentOptionsArray.forEach((fOption) => {
            var i = facet.data.findIndex(
              (e) => e.value === fOption.getAttribute("data-filter-value")
            );
            if (i > -1) {
              fOption.classList.add("show");
              fOption.querySelector(
                ".collection-filter__option__count"
              ).innerHTML = "(" + facet.data[i].count + ")";
            } else {
              fOption.classList.remove("show");
            }
          });
        }
      });
      newFacets.forEach((facet) => {
        if (facet.type == "terms") {
          var currentOptionsArray = this.querySelectorAll(
            '.collection-filters-mobile [data-filter-field="' +
              facet.field +
              '"] li'
          );
          currentOptionsArray.forEach((fOption) => {
            var i = facet.data.findIndex(
              (e) => e.value === fOption.getAttribute("data-filter-value")
            );
            if (i > -1) {
              fOption.classList.add("show");
              fOption.classList.remove("disabled");
              fOption.querySelector("input").removeAttribute("disabled");
            } else {
              fOption.classList.remove("show");
              fOption.classList.add("disabled");
              fOption.querySelector("input").setAttribute("disabled", "");
            }
          });
        }
      });
      if (this.visualFilters == "true") {
        this.querySelectorAll("#nosto-visual-filters .visual-filter").forEach(
          (vFilter) => {
            var vCat = vFilter.getAttribute("data-category");
            var vVal = vFilter.getAttribute("value");
            var filterOption = this.querySelector(
              '.collection-filter__options__item [value="' +
                vVal +
                '"][data-category="' +
                vCat +
                '"]'
            );
            if (filterOption) {
              if (filterOption.checked == false) {
                vFilter.classList.remove("active");
              } else {
                vFilter.classList.add("active");
              }
            }
          }
        );
      }
    }
  }
  customElements.define("nosto-collection", nostoCollection);
}
if (!customElements.get("nosto-collection-grid")) {
  class nostoCollectionGrid extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.collectionArray = [];
      this.collectionData = {};
      this.collectionId = this.getAttribute("data-collection-id");
      this.international = this.getAttribute("data-international");
      this.collectionSize = parseInt(this.getAttribute("data-collection-size"));
      this.querySelector(".ss-skeleton-grid").style.visibility = "visible";
      this.getNostoCollection();
      this.querySelector(".collection-paginate a").addEventListener(
        "click",
        function () {
          var newFrom = parseInt(
            this.querySelector(".collection-paginate a").getAttribute(
              "data-from"
            )
          );
          this.getNostoCollection(newFrom);
        }.bind(this)
      );
    }
    getNostoCollection(
      collection_from = 0,
      collection_reset = false,
      collection_size = this.collectionSize
    ) {
      var trackType;
      var apiOptions = {};
      apiOptions.products = {
        facets: ["*"],
        fields: [
          "name",
          "price",
          "listPrice",
          "url",
          "imageUrl",
          "alternateImageUrls",
          "customFields.key",
          "customFields.value",
          "categories",
          "tags1",
        ],
        size: collection_size,
        from: collection_from,
      };
      apiOptions.products.categoryId = this.collectionId;
      trackType = "category";
      nostojs((api) => {
        api
          .search(apiOptions, {
            track: trackType,
            redirect: true,
          })
          .then((response) => {
            var products = response.products.hits;
            var container = this.querySelector(".main-collection-product-grid");
            if (collection_reset) {
              container.innerHTML = "";
            }
            products.forEach((nostoItem) => {
              var metafields = [];
              nostoItem.videoDesktop = null;
              nostoItem.videoMobile = null;
              nostoItem.videoUnisex = null;
              nostoItem.videoUnisex_womens_image_position = null;
              nostoItem.videoUnisex_mens_image_position = null;
              nostoItem.videoUnisex_mens_plp_desktop_video = null;
              nostoItem.videoUnisex_mens_plp_mobile_video = null;

              nostoItem.customFields.forEach((field, i) => {
                if (field.key == "images-image_icon") {
                  metafields.push(field);
                }
                if (field.key == "video-plp_desktop_video") {
                  var video = JSON.parse(field.value);
                  nostoItem.videoDesktop = video[0].src;
                }
                if (field.key == "video-plp_mobile_video") {
                  var video = JSON.parse(field.value);
                  nostoItem.videoMobile = video[0].src;
                }
                if (field.key == "video-unisex") {
                  nostoItem.videoUnisex = field.value;
                }
                if (field.key == "video-unisex_womens_image_position") {
                  nostoItem.videoUnisex_womens_image_position = parseInt(
                    field.value
                  );
                }
                if (field.key == "video-unisex_mens_image_position") {
                  nostoItem.videoUnisex_mens_image_position = parseInt(
                    field.value
                  );
                }
                if (field.key == "video-unisex_mens_plp_dekstop_video") {
                  var video = JSON.parse(field.value);
                  nostoItem.videoUnisex_mens_plp_desktop_video = video[0].src;
                }
                if (field.key == "video-unisex_mens_plp_mobile_video") {
                  var video = JSON.parse(field.value);
                  nostoItem.videoUnisex_mens_plp_mobile_video = video[0].src;
                }
              });
              nostoItem.metafields = metafields;
              delete nostoItem.customFields;
              var categories = nostoItem.categories.map((category) =>
                category.toLowerCase()
              );
              var collectionTitle = "";
              categories.forEach((category) => {
                if (category.startsWith("collection - ")) {
                  collectionTitle = category;
                }
              });
              var singleProd = "false";
              var collectionHandle = "";
              if (collectionTitle != "") {
                var collectionHandle = collectionTitle
                  .replaceAll(" - ", "-")
                  .replaceAll(": ", "-")
                  .replaceAll(" & ", "-")
                  .replaceAll(" ", "-")
                  .replaceAll("/", "-")
                  .replaceAll('"', "")
                  .replaceAll("'", "")
                  .replaceAll(".", "-")
                  .replaceAll("--", "-");
                if (this.collectionArray.indexOf(collectionHandle) === -1) {
                  this.collectionArray.push(collectionHandle);
                }
              } else {
                singleProd = "true";
              }
              var buildItem =
                '<li class="collection-grid__item"><nosto-collection-item data-type="' +
                trackType +
                '" data-collection="false" data-international="' +
                this.international +
                '" data-collection-handle="' +
                collectionHandle +
                '" data-single-product="' +
                singleProd +
                '" data-gendered="' +
                this.gendered +
                '">';
              buildItem +=
                '<data class="nosto-data" style="display:none;">' +
                JSON.stringify(nostoItem) +
                "</data>";
              buildItem += "</nosto-collection-item></li>";
              container.insertAdjacentHTML("beforeend", buildItem);
            });
            var pagination = this.querySelector("#cc-pagination");
            var countP = products.length + response.products.from;
            var totalP = response.products.total;
            pagination.querySelector(".collection-product-count").innerHTML =
              "Showing " + countP + " of " + totalP;
            if (countP != totalP) {
              pagination
                .querySelector(".collection-paginate")
                .classList.add("visible");
              pagination
                .querySelector(".collection-paginate a")
                .setAttribute("data-from", countP);
            } else {
              pagination
                .querySelector(".collection-paginate")
                .classList.remove("visible");
            }
            this.querySelector(".ss-skeleton-grid").style.display = "none";
            this.getCollectionData();

            api
              .defaultSession()
              .setResponseMode("HTML")
              .viewFrontPage()
              .setPlacements(api.placements.getPlacements())
              .load()
              .then((response) => {
                api.placements.injectCampaigns(response.recommendations);
              });
          });
      });
    }
    getCollectionData() {
      var mainEl = this;
      this.collectionArray.forEach((collection) => {
        fetch("/collections/" + collection + "?view=nosto-api")
          .then((response) => {
            if (!response.ok) {
              throw new Error("Collection Not found: " + collection);
            }
            return response.json();
          })
          .then((data) => {
            var toSave = data;
            mainEl.collectionData[collection] = toSave;
            collectionData[collection] = toSave;
            var markAvailable = mainEl.querySelectorAll(
              '[data-collection-handle="' + collection + '"]'
            );
            markAvailable.forEach((mark) => {
              mark.setAttribute("data-collection", "true");
            });
          })
          .catch((error) => {
            console.error(error);
            var markSingle = mainEl.querySelectorAll(
              '[data-collection-handle="' + collection + '"]'
            );
            markSingle.forEach((mark) => {
              mark.setAttribute("data-single-product", "true");
            });
          });
      });
    }
  }
  customElements.define("nosto-collection-grid", nostoCollectionGrid);
}
